import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';

import theme from '~/theme';

import { small, medium, large, a, p } from '~/styles/typography';

import { formatText } from '~/utilities/helpers';

const fontSizes = {
    small,
    medium,
    large
};

const StyledParagraph = styled.p`
    ${p};
    text-align: ${({ align }) => align || 'left'};
    ${({ fontSize }) => (fontSize ? fontSizes[fontSize] : fontSizes.medium)};
    margin-bottom: 25px;

    @media (min-width: ${theme.breakpoint.tablet}) {
        margin-bottom: 35px;
    }

    a {
        ${a};
    }
`;

const Paragraph = ({
    anchor = '',
    align = 'left',
    content,
    fontSize = 'medium',
    className = ''
}) => (
    <StyledParagraph
        {...(anchor ? { id: anchor } : {})}
        {...{ align, fontSize, className }}
    >
        {formatText(content)}
    </StyledParagraph>
);

Paragraph.propTypes = {
    content: PropTypes.string.isRequired,
    anchor: PropTypes.string,
    align: PropTypes.string,
    fontSize: PropTypes.string,
    className: PropTypes.string
};

export default Paragraph;
